import { Payment } from '@vsolv/packages/payments/domain';
import { Distributor } from '@wsphere/distributors/domain';
import { Model as WarrantyModel } from '../warranty/model';
import { Status } from './status';

/** A seller's selection of unfunded warranties, paid together. The money lives on the Payment. */
export interface Model {
  id: string;

  distributorId: string;
  /** Narrowed on purpose: a batch renders the seller's name, never their banking details. */
  distributor?: Pick<Distributor.Model, 'id' | 'name'>;

  paymentId: string | null;
  payment?: Payment.Model | null;

  status: Status;

  /** Set while DRAFT; null once a payment exists. */
  expiryDate: Date | null;

  /**
   * The distributor's outstanding SELLER clawback balance (from cancelled contracts) folded
   * into this batch's charge, in cents — frozen at CREATE time, on top of the sum of
   * `warranties[].amountApplied`. Zero when the seller owed nothing. See the batch-payment
   * clawback-recovery domain doc: this is how a seller's cancellation debt is actually
   * collected, since they never pay it back directly — it's withheld from their next remittance.
   */
  clawbackRecoveryAmount: number;

  warranties?: BatchPaymentWarranty[];

  created: Date;
  modified: Date;
}

export interface BatchPaymentWarranty {
  id: string;

  batchPaymentId: string;
  batchPayment?: Model;

  warrantyId: string;
  /** Narrowed to the retrieve select, keeping coverages/customer/documents out. netAmountDue lives on the entity. */
  warranty?: Pick<WarrantyModel, 'id' | 'contractNumber' | 'status'> & { netAmountDue: number | null };

  /** Snapshot of the warranty's net amount due when it joined, in cents. */
  amountApplied: number;

  created: Date;
}

export const MAX_BATCH_SIZE = 100;

export const DEFAULT_TTL_MINUTES = 60;
